// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".exitButton[data-v-36e30d03] {\n  position: absolute;\n  right: 25px;\n  top: 10px;\n  z-index: 1;\n}", ""]);
// Exports
module.exports = exports;
